<mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>
<div [ngClass]="{ zonaoculta: loading === true }">
  <app-buttons
    (save)="submit()"
    (close)="destroy()"
    (discard)="discard()"
    [buttonsWrap]="'panel'"
    [modificar]="modificar"
  ></app-buttons>
  <div class="editor-registro">
    <div class="divForm">
      <form [formGroup]="editTemporadaForm" (ngSubmit)="submit()">
        <div class="temporada-form">
          <section class="section-card">
            <div class="section-header">
              <h3 class="section-title">
                {{ translation?.InfoTemporada || 'Información de la temporada' }}
              </h3>
              <p class="section-subtitle">
                {{ translation?.InfoTemporadaHint || 'Complete los datos básicos para identificar la temporada.' }}
              </p>
            </div>

            <div class="section-grid section-grid--basic">
              <mat-form-field appearance="outline">
                <mat-label>{{ translation?.Nombre || 'Nombre' }}</mat-label>
                <input matInput formControlName="Nombre" maxlength="100" />
                <mat-error *ngIf="validateFields('Nombre')">
                  {{ getErrorMessage("Nombre") }}
                </mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline" class="descripcion-field">
                <mat-label>{{ translation?.Descripcion || 'Descripción' }}</mat-label>
                <textarea
                  matInput
                  formControlName="Descripcion"
                  rows="2"
                  maxlength="500"
                  (input)="onDescripcionInput($event)"
                ></textarea>
                <mat-hint align="end">
                  {{ (editTemporadaForm.get('Descripcion')?.value?.length || 0) }}/500
                </mat-hint>
                <mat-error *ngIf="validateFields('Descripcion')">
                  {{ getErrorMessage("Descripcion") }}
                </mat-error>
              </mat-form-field>
            </div>
          </section>

          <section class="section-card">
            <div class="section-header">
              <h3 class="section-title">{{ translation?.Configuracion || 'Configuración' }}</h3>
              <p class="section-subtitle">
                {{ translation?.ConfiguracionHint || 'Ajuste el color y el estado de la temporada.' }}
              </p>
            </div>

            <div class="section-grid section-grid--config">
              <mat-form-field appearance="outline" class="color-field">
                <mat-label>{{ translation?.Color || 'Color' }}</mat-label>
                <div class="color-input-row">
                  <input
                    type="color"
                    [value]="colorParaCalendario"
                    (input)="onColorPickerChange($event)"
                    (mousedown)="onColorPickerMouseDown($event)"
                    (mouseup)="onColorPickerMouseUp($event)"
                    (mouseleave)="onColorPickerMouseUp($event)"
                    class="color-picker-input"
                  />
                  <mat-select
                    [value]="colorSelectValue"
                    (selectionChange)="onColorSelectChange($event.value)"
                  >
                    <mat-option *ngFor="let c of coresDisponiveis" [value]="c.value">
                      {{ c.label }}
                    </mat-option>
                    <mat-option [value]="'__custom__'">
                      {{ translation?.Personalizada || 'Personalizada' }}
                    </mat-option>
                  </mat-select>
                </div>
                <mat-hint *ngIf="isCustomColor">
                  {{ translation?.ColorCustomHint || 'Color personalizado (hex)' }}
                </mat-hint>
              </mat-form-field>

              <mat-form-field *ngIf="isCustomColor" appearance="outline" class="color-field">
                <mat-label>{{ translation?.Color || 'Color' }}</mat-label>
                <input
                  matInput
                  formControlName="Color"
                  placeholder="#RRGGBB o #RRGGBBAA"
                  maxlength="9"
                  (input)="onHexColorInput($event)"
                />
                <mat-error *ngIf="validateFields('Color')">
                  {{ getErrorMessage("Color") }}
                </mat-error>
              </mat-form-field>

              <div class="toggles">
                <div class="toggle-item">
                  <span class="toggle-label">{{ translation?.Activa || 'Activa' }}</span>
                  <mat-slide-toggle formControlName="Activa"></mat-slide-toggle>
                </div>
                <div class="toggle-item">
                  <span class="toggle-label">{{ translation?.PorDefecto || 'Por defecto' }}</span>
                  <mat-slide-toggle formControlName="PorDefecto"></mat-slide-toggle>
                </div>
              </div>
            </div>
          </section>

          <section class="section-card fechas-wrapper">
          <div class="fechas-header">
            <h3 class="fechas-title">
              {{ translation?.SelectorFechasTemporada || 'Selector de fechas' }}
            </h3>
            <p class="fechas-subtitle">
              {{
                translation?.SelectorFechasTemporadaHint ||
                  'Seleccione la fecha de inicio de temporada y la fecha de fin de temporada.'
              }}
            </p>
          </div>
          <div class="form-group fechas-section">
            <mat-form-field appearance="outline">
              <mat-label>
                {{
                  translation?.FechaInicioTemporada ||
                    translation?.FechaInicio ||
                    'Fecha de inicio de temporada'
                }}
              </mat-label>
              <input
                matInput
                [matDatepicker]="pickerInicio"
                formControlName="FechaInicio"
                [min]="minFechaPicker"
                [max]="maxFechaPicker"
                maxlength="10"
              />
              <mat-datepicker-toggle matSuffix [for]="pickerInicio"></mat-datepicker-toggle>
              <mat-datepicker
                #pickerInicio
                [startAt]="startAtInicioPicker"
                startView="year"
                panelClass="limited-years-panel"
              ></mat-datepicker>
              <mat-error *ngIf="validateFields('FechaInicio')">
                {{ getErrorMessage("FechaInicio") }}
              </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>
                {{
                  translation?.FechaFinTemporada ||
                    translation?.FechaFin ||
                    'Fecha de fin de temporada'
                }}
              </mat-label>
              <input
                matInput
                [matDatepicker]="pickerFin"
                formControlName="FechaFin"
                [min]="minFechaPicker"
                [max]="maxFechaPicker"
                maxlength="10"
              />
              <mat-datepicker-toggle matSuffix [for]="pickerFin"></mat-datepicker-toggle>
              <mat-datepicker
                #pickerFin
                [startAt]="startAtFinPicker"
                startView="year"
                panelClass="limited-years-panel"
              ></mat-datepicker>
              <mat-error *ngIf="validateFields('FechaFin')">
                {{ getErrorMessage("FechaFin") }}
              </mat-error>
            </mat-form-field>
          </div>
          </section>

          <section class="section-card meses-calendarios" #calendariosRoot>
          <h3 class="selector-title">{{ translation?.SelectorMeses || 'Selector de meses de la temporada' }}</h3>
          <p class="instrucao-checkbox-calendario">
            {{ translation?.InstrucaoCheckboxCalendario || 'Casillas: marque para mostrar el mes abajo; desmarque para ocultar. En los calendarios: haga clic en un día para seleccionar; mantenga pulsado el botón izquierdo del ratón y arrastre para marcar varios días.' }}
          </p>
          <div class="meses-checkboxes-row">
            <mat-checkbox
              *ngFor="let m of getMesesParaExibir(); trackBy: trackByMesKey"
              [formControl]="getMesVisControl(m.mes)"
              class="mes-checkbox"
            >
              {{ m.label }}
            </mat-checkbox>
          </div>
          <p class="hint" *ngIf="loadingOcupados">{{ translation?.Cargando || 'Cargando días ocupados...' }}</p>
          <h4 class="dias-title">{{ translation?.Dias || 'Días' }}</h4>
          <div class="calendarios-grid">
            <div *ngFor="let m of getMesesCalendarioVisibles(); trackBy: trackByMesKey" class="calendario-card" [class.desactivado]="!isMesDentroDelRango(m.mes)">
              <div class="calendario-header">{{ m.label }}</div>
              <div class="calendario-body">
                <div class="dias-semana">
                  <span>L</span><span>M</span><span>X</span><span>J</span><span>V</span><span>S</span><span>D</span>
                </div>
                <div class="dias-grid">
                  <ng-container *ngFor="let _ of [].constructor(getDiaOffset(m.mes))">
                    <span class="dia-vacio"></span>
                  </ng-container>
                  <button
                    *ngFor="let d of getDiasDelMes(m.mes); trackBy: trackByDiaKey"
                    type="button"
                    class="dia-btn"
                    [class.selected]="isDiaSeleccionado(m.mes, d)"
                    [class.occupied]="isDiaOcupado(m.mes, d)"
                    [class.dia-btn-disabled]="!isDiaSeleccionado(m.mes, d) && (isDiaOcupado(m.mes, d) || !isDiaDentroDelRango(m.mes, d))"
                    [disabled]="!isDiaSeleccionado(m.mes, d) && (isDiaOcupado(m.mes, d) || !isDiaDentroDelRango(m.mes, d))"
                    [attr.aria-disabled]="(isDiaOcupado(m.mes, d) || !isDiaDentroDelRango(m.mes, d)) ? 'true' : null"
                    (click)="onDiaClick(m.mes, d)"
                    (pointerdown)="onDiaPointerDown(m.mes, d)"
                    (pointerenter)="onDiaMouseEnter(m.mes, d)"
                  >
                    {{ d }}
                  </button>
                </div>
              </div>
            </div>
          </div>
          </section>

          <section class="section-card centros-section">
            <div class="section-header">
              <h3 class="section-title">{{ translation?.Centros || 'Centros' }}</h3>
              <p class="section-subtitle">
                {{ translation?.CentrosHint || 'Asigne los centros que pertenecen a esta temporada.' }}
              </p>
            </div>

            <customan-dual-list
              [source]="centrosSinAsignar"
              [(destination)]="centrosAsignados"
              key="pkId"
              display="Nombre"
              [format]="format"
              [filter]="true"
            >
            </customan-dual-list>
          </section>
        </div>
      </form>
    </div>
  </div>
</div>
